import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { useIsEmbeddedMobile } from '../../../_hooks/useIsEmbeddedMobile';
import { Container } from './LabeledList.styles';

interface Props {
  data: {
    label: string;
    value: string;
    isHighlighted: boolean;
  }[];
}

export const LabeledList = ({ data }: Props) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();

  return (
    <Container isEmbeddedMobile={isEmbeddedMobile}>
      {data.map(({ label, value, isHighlighted }) => (
        <Box key={label} display="flex" justifyContent="space-between">
          <Text
            fontWeight={isHighlighted ? 600 : isEmbeddedMobile ? 500 : 400}
            pl={isHighlighted ? 0 : 10}
          >
            {label}
          </Text>

          <Text
            variant="tabular"
            textAlign="right"
            fontWeight={isHighlighted ? 600 : isEmbeddedMobile ? 500 : 400}
          >
            {value}
          </Text>
        </Box>
      ))}
    </Container>
  );
};
